import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors) => ({
  container: {
    backgroundColor: colors.backgroundPrimary,
    borderRadius: theme.borderRadius.s,

    variants: {
      variant: {
        default: {
          backgroundColor: colors.backgroundPrimary,
          borderWidth: 0,
        },
        elevated: {
          backgroundColor: colors.backgroundPrimary,
          shadowColor: colors.textPrimary,
          shadowOffset: { width: 0, height: 2 },
          shadowOpacity: 0.1,
          shadowRadius: 8,
          elevation: 4,
          borderWidth: 0,
        },
        outlined: {
          backgroundColor: colors.backgroundPrimary,
          borderWidth: 1,
          borderColor: colors.borderPrimary,
        },
      },
    },
  },
}));
